import slice from './slice';

export const { setCollapse, setSelectedOrder, setOrderFormData, setAssignedDrone, setAssignMethod, setMissionId } = slice.actions;